/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import './user-panel.scss';
import { Button } from 'devextreme-react/button';
import Form, {
  ButtonItem,
  GroupItem,
  SimpleItem,
  Label,
  CompareRule,
  RequiredRule,
  PatternRule,
} from 'devextreme-react/form';
import { TextBox } from 'devextreme-react';
import { Popup } from 'devextreme-react/popup';
import { ToasterMessage } from '../../components/sharedComponents/';
import { resetPasswordAction } from '../../store/action/userAction';
import { regularExpression, responseOkCode } from '../../constant';
import serviceCall from '../../store/serviceCall/index';
/* NPM Imports End */

export const ProfileForm = ({ user: { userdetail } }) => {
  const { email, pkId } = userdetail;
  const { userName, contactNumber, role } = userdetail.customers[0];
  const [passPopup, setPassPopup] = useState(false);
  const dispatch = useDispatch();
  const handleEmail = (dataField, mode = 'text') => (
    <TextBox text={dataField} mode={mode} readOnly={true}></TextBox>
  );

  const items = [
    {
      text: 'Email',
      renderField: handleEmail(email, 'email'),
    },
    {
      text: 'User Name',
      renderField: handleEmail(userName),
    },
    {
      text: 'Role',
      renderField: handleEmail(role),
    },
    {
      text: 'Phone Number',
      renderField: handleEmail(contactNumber, 'tel'),
    },
  ];

  const resetForm = () =>
    passPopup === true ? (
      <>
        <form className="passwordResetpopup" onSubmit={handleSubmit}>
          <Form
            formData={userdetail}
            width={'96%'}
            className="set_profile_margin"
            labelLocation="left">
            <GroupItem>
              <SimpleItem
                dataField="password"
                editorType="dxTextBox"
                editorOptions={{ mode: 'password' }}>
                <Label text="Password" />
                <RequiredRule message="Password is required" />
                <PatternRule
                  message="Password must be 8 to 150 Characters, which contain atleast one numeric digit, one special character, one uppercase and one lowercase."
                  pattern={regularExpression.Password}
                />
              </SimpleItem>
            </GroupItem>{' '}
            <GroupItem>
              <SimpleItem
                editorType="dxTextBox"
                editorOptions={{ mode: 'password' }}>
                <Label text="Confirm Password" />
                <RequiredRule message="Confirm Password is required" />
                <CompareRule
                  message="Password and Confirm Password do not match"
                  comparisonTarget={passwordComparison}
                />
              </SimpleItem>
            </GroupItem>
            <GroupItem>
              <ButtonItem
                horizontalAlignment="right"
                buttonOptions={buttonOptions}
              />
            </GroupItem>
          </Form>
          <Button
            className="cancel-button-custom1"
            type="normal"
            text="Cancel"
            onClick={() => {
              passPopupHiding();
            }}
          />
        </form>
      </>
    ) : (
      ''
    );
  const [buttonOptions] = useState({
    text: 'Save',
    type: 'default',
    useSubmitBehavior: true,
  });
  function resetPass() {
    setPassPopup(true);
  }
  function passPopupHiding() {
    userdetail.password = '';
    setPassPopup(false);
  }
  const handleSubmit = e => {
    const customerData = {
      usersUuid: pkId,
      password: userdetail.password,
    };
    dispatch(resetPasswordAction('Users/ResetPassword', customerData));
    serviceCall
      .resetPassword('Users/ResetPassword', customerData)
      .then(response => {
        if (response.status === responseOkCode) {
          ToasterMessage('success', 'You have reset password successfully');
        }
      });
    e.preventDefault();
    setPassPopup(false);
  };
  function passwordComparison() {
    return userdetail.password;
  }
  return (
    <>
      <Form
        formData={userdetail}
        width={'96%'}
        className="set_profile_margin"
        labelLocation="left">
        <GroupItem>
          {items.map((val, index) => (
            <SimpleItem key={index}>
              <div className="dx-field">
                <div className="dx-field-label item_width">{val.text}</div>
                <div
                  className="dx-field-value dx-profile"
                  data-cy={`H-${val.text.replace(/\s/g, '')}-Textbox`}>
                  {val.renderField}
                </div>
              </div>
            </SimpleItem>
          ))}
        </GroupItem>
      </Form>
      <div data-cy="H-ResetPassword-Button">
        <Button
          text="Reset Password"
          stylingMode="contained"
          type="default"
          onClick={resetPass}
          className="reset-button-profile"
        />
      </div>
      <Popup
        height={240}
        width={550}
        className={'popup-button'}
        title="Reset Password"
        visible={passPopup}
        contentRender={resetForm}
        onHiding={passPopupHiding}></Popup>
    </>
  );
};
